export interface HqRuntimeConfig {
  /** 主业务 API 根（含 `/api` 段）。 */
  apiBase: string;
  /** 资源服务根（含 `/res` 段）。 */
  resBase: string;
  appTitle: string;
  uploadMaxMb: number;
  enableDebug: boolean;
}

const fallback: HqRuntimeConfig = {
  apiBase: '/api',
  resBase: '/res',
  appTitle: '行政后勤物资管理平台',
  uploadMaxMb: 50,
  enableDebug: false
};

/** 本机 dev 强制同源，走 Vite 反代（5003→5001/5002）；生产绝对地址由 config.js 提供。 */
const devOverride: Partial<HqRuntimeConfig> = import.meta.env.DEV ? { apiBase: '/api', resBase: '/res' } : {};

/** 运行时配置：`public/config.js` 覆盖默认值，同一份产物可跨环境部署。 */
const runtime: HqRuntimeConfig = { ...fallback, ...(window.__HQ_CONFIG__ ?? {}), ...devOverride };

export const config: HqRuntimeConfig = runtime;

export const appTitle = config.appTitle;

/** 账号等级中文名收敛在 `@hq/utils`，此处 re-export 保持端内既有 import 不变。 */
export { LEVEL_LABELS, levelLabel } from '@hq/utils';
